import DataGridComponent from "components/DataGridComponent/DataGridComponent"
import { DeleteDialog } from "components/DeleteDialog/DeleteDialog"
import { Device, Skill } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { AddSkillDialog } from "./AddSkillDialog"

export const skillEmpty: Skill = {
  id: "NEW",
  name: "",
  person: [],
  testEquipment: [],
}

const AdminSkillManagement = () => {
  const { skills, employees } = useStoreState((state) => state)
  const { updateSkill, deleteSkill, fetchSkills } = useStoreActions(
    (actions) => actions
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [formState, setFormState] = useState<Skill>(skillEmpty)
  const [openDelete, setOpenDelete] = useState(false)
  const [toDelete, setToDelete] = useState<string[]>([])
  const { fetchEmployees } = useStoreActions((actions) => actions)

  useEffect(() => {
    const loadEmployees = async () => {
      try {
        await fetchEmployees({ fresh: false })
      } catch (err) {
        console.error("Error loading employees:", err)
      }
    }
    loadEmployees()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    fetchSkills()
  }, [fetchSkills])

  const handleEdit = (id: string) => {
    if (id === "NEW") {
      setFormState({
        ...skillEmpty,
        id: "NEW",
      })
    } else {
      const skill = skills.find((tb) => tb.id === id)
      if (skill) {
        setFormState(skill)
      }
    }
    setDialogOpen(true)
  }

  const handleDelete = (id: string[]) => {
    setOpenDelete(true)
    setToDelete(id)
  }

  const handleDeleteSelected = () => {
    deleteSkill(toDelete)
    setToDelete([])
    setOpenDelete(false)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
  }

  const handleFormSubmit = (arg: Skill) => {
    updateSkill(arg)
    setDialogOpen(false)
  }

  const columns = [
    { field: "name", headerName: "Bezeichnung", width: 300 },
    {
      field: "person",
      headerName: "Mitarbeiter",
      width: 400,
      wrapText: true,
      valueGetter: (value: string[]) =>
        value && value.length > 0
          ? value
              .map((item) => {
                const emplo = employees.find((e) => e.id === item)
                return emplo?.EmployeeName
              })
              .join(", ")
          : "",
    },
    {
      field: "testEquipment",
      headerName: "Testequipment",
      width: 200,
      wrapText: true,
      valueGetter: (value: Device[]) =>
        value && value.length > 0
          ? value.map((item) => `${item.barcode} ${item.name}`).join(", ")
          : "",
    },
  ]

  return (
    <>
      <DataGridComponent
        columns={columns}
        rows={skills}
        getRowId={(row) => row.id}
        onEdit={handleEdit}
        onAdd={() => handleEdit("NEW")}
        onDelete={handleDelete}
      />

      <AddSkillDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        formState={formState}
        onSubmit={handleFormSubmit}
      />

      <DeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onDelete={handleDeleteSelected}
      />
    </>
  )
}

export default AdminSkillManagement
